import { type ComponentType, lazy } from "react";

/**
 *
 * @example
 * import { lazy } from 'react'
 * import { lazyNamedImport } from '@infinidus/react-utils'
 *
 * // Normally, when MyComponent is the default export
 * const LazyDefaultComponent = lazy(() => import('./MyComponent'))
 *
 * // With named import, such as when imported normally as `import { MyComponent } from './MyComponent'`
 * const { MyComponent } = lazyNamedImport(() => import('./MyComponent'), 'MyComponent')
 */
export const lazyNamedImport = <
  Key extends keyof T,
  T extends { [key in Key]: ComponentType<any> },
>(
  factory: () => Promise<T>,
  name: Key,
) => ({
  [name]: lazy(async () => {
    const mod = await factory();
    return { default: mod[name] };
  }),
});
